export default __webpack_public_path__ + "static/media/PrafullAnubhai.90ca31aa.png";